import { useCallback } from 'react';

import { useGeneralStore } from '../store/useGeneralStore';

export const useValidationDataTable = (keyTable) => {
	const { setDataTable, dataTable } = useGeneralStore();

	const handleChange = useCallback(
		({
			event: {
				target: { value = '' },
			},
			cellKey,
			rowData,
		}) => {
			const updatedRowData = rowData.data.map((item) =>
				item.key === cellKey ? { ...item, value } : item,
			);

			const updatedBody = dataTable[keyTable].body.map((item) =>
				item.idRow === rowData.idRow
					? { ...rowData, isUpdatedRow: true, data: updatedRowData }
					: item,
			);

			setDataTable({
				...dataTable,
				[keyTable]: {
					...dataTable[keyTable],
					body: updatedBody,
				},
			});
		},
		[dataTable, keyTable, setDataTable],
	);

	const handleBuildFormValidations = useCallback(
		({ validations, isDisabled }) => {
			let validationsParams = {};

			if (validations) {
				const { isRequired, number = {}, string = {} } = validations;

				const { pattern: patternNumber = '', max, min } = number;
				const { pattern: patternString = '', maxLength, minLength } = string;

				validationsParams = {
					required: {
						value: isDisabled ? !isDisabled : isRequired,
						message: 'Completa el campo',
					},
					...((patternNumber || patternString) && {
						pattern: {
							value: new RegExp(patternNumber || patternString || ''),
							message: 'Campo inválido',
						},
					}),
					...(max && {
						max: {
							value: max,
							message: `El valor máximo es ${max}`,
						},
					}),
					...(min && {
						min: {
							value: min,
							message: `El valor mínimo es ${min}`,
						},
					}),
					...(maxLength && {
						maxLength: {
							value: maxLength,
							message: `El valor no puede exceder de ${maxLength} caracteres`,
						},
					}),
					...(minLength && {
						minLength: {
							value: minLength,
							message: `El valor no puede ser menor a ${minLength} caracteres`,
						},
					}),
					onChange: handleChange,
				};
			}

			return validationsParams;
		},
		[handleChange],
	);

	return {
		handleChange,
		handleBuildFormValidations,
	};
};
